import { useKeymap } from "@features/keymap/useKeymap"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { ControlButton, useReactFlow } from "reactflow"
import { FitViewIcon } from "@components/Icons/FitViewIcon"
import { shortcuts } from "@features/keymap/shortcuts"

export const FitViewButton = () => {
  const reactFlowInstance = useReactFlow()
  const keymap = useKeymap()

  const handleFitView = () => reactFlowInstance.fitView()

  return (
    <>
      <KeyBinding bind={shortcuts["fit-view"]} onKeyDown={handleFitView} />
      <ControlButton
        data-testid="graph-controls-fit-view-btn"
        onClick={handleFitView}
        title={keymap.getKeymaps().byId.get("fit-view")?.desc}
      >
        <FitViewIcon />
      </ControlButton>
    </>
  )
}
